module.exports = __webpack_public_path__ + "static/media/contentanalysis.88f53e27.pdf";